/*
 * @fileOverView Form component definition
 */

import Vue from 'vue';
import Form from 'components/foundation/forms/form/form.mixin';

/**
 * [Form Vue]
 * @type {class}
 */
Vue.component('form-vue', {
  mixins: [Form]
});
